import { sectionContainerAtom } from '@ingenico/react-section-utils';
import type { LogicalDeviceViewOutputModalProps } from '@ingenico/type-mfe-contracts/domains';
import deepEqual from 'fast-deep-equal';
import { createStore, Provider } from 'jotai';
import type { ReactElement } from 'react';
import { memo, useMemo } from 'react';
import { deviceManagementContainer } from '../../container.const';
import { FileOutputFormularyModal } from '../file-output-formulary-modal/FileOutputFormularyModal.ctrl';

function ExposedLogicalDeviceViewOutputModalContent({
  isOpen,
  logicalDeviceId,
  onClose,
}: LogicalDeviceViewOutputModalProps): ReactElement {
  return <FileOutputFormularyModal isOpen={isOpen} logicalDeviceId={logicalDeviceId} onClose={onClose} />;
}

function ExposedLogicalDeviceViewOutputModalCpnt(props: LogicalDeviceViewOutputModalProps): ReactElement {
  // Pre-initialize the section container on a fresh store before any child renders.
  // @ingenico/react-section-utils reads sectionContainerAtom synchronously during render and
  // throws if it is null, so the value must be set before the Provider mounts its children.
  const store = useMemo(() => {
    const sectionStore = createStore();
    sectionStore.set(sectionContainerAtom, deviceManagementContainer);
    return sectionStore;
  }, []);

  return (
    <Provider store={store}>
      <ExposedLogicalDeviceViewOutputModalContent {...props} />
    </Provider>
  );
}

export const ExposedLogicalDeviceViewOutputModal = memo(ExposedLogicalDeviceViewOutputModalCpnt, deepEqual);
